<template>

<div>
  <!-- MODAL LOADING -->
  <div
    ref='modalLoading'
    id="modalLoading"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modalLoading"
    aria-hidden="true"
  >
    <div class="modal modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">

        <div class="modal-header">
          <h5 class="modal-title">Carregando...</h5>
        </div>

        <div class="modal-body">
          <div class="d-flex justify-content-center mb-3">
            <b-spinner label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </div>

  <LDBsTable
    url="drive-behavior"
    defaultSort="data_hora_comportamento_motorista"
    defaultOrder="desc"
    :query="queryToUse"
    :columns="columns"
    :clear="clear"
    :defaultOptions='options'
  >
    <div class="form-group col-lg-4">
      <label for="client">{{ $t('client') }}</label>
      <Combobox
        class="bg-white"
        name='client'
        :placeholder="$t('select_a_item')"
        :options="clients"
        :getOptionLabel="item => `${item.CLI_ID} - ${item.CLI_DSC}`"
        :initial-value="query.client"
        v-model="query.client"
        :reduce="client => client.CLI_ID"
      />
    </div>

    <div class="form-group col-lg-4">
      <label for="vehicle">{{ $t('vehicle') }}</label>
      <Combobox
        class="bg-white"
        name='vehicle'
        :placeholder="$t('select_a_item')"
        :getOptionLabel="item => `${item.VEI_ID} - ${item.VEI_PLC}`"
        :options="vehicles"
        :initial-value="query.vehicle"
        v-model="query.vehicle"
        :reduce="vehicle => vehicle.VEI_ID"
      />
    </div>

    <div class="form-group col-lg-4">
      <label for="drive">{{ $t('drive') }}</label>
      <Combobox
        class="bg-white"
        name='drive'
        :placeholder="$t('select_a_item')"
        :getOptionLabel="item => `${item.MOT_ID} - ${item.MOT_NOM}`"
        :options="drives"
        :initial-value="query.drive"
        v-model="query.drive"
        :reduce="drive => drive.MOT_ID"
      />
    </div>

    <div class="form-group col-lg-4">
      <label for="reason">{{ $t('reason') }}</label>
      <Combobox
        class="bg-white"
        name='reason'
        :placeholder="$t('select_a_item')"
        :options="reasons"
        :getOptionLabel="item => `${item.id} - ${item.label}`"
        :initial-value="query.reason"
        v-model="query.reason"
        :reduce="reason => reason.id"
      />
    </div>

    <div class="form-group col-lg-4">
        <label for="period_start">{{ $t('period_start') }}</label>
        <input
          type="date"
          id="period_start"
          name="period_start"
          class="form-control"
          :placeholder="$t('ph_period_start')"
          v-model="query.start"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="period_end">{{ $t('period_end') }}</label>
        <input
          type="date"
          id="period_end"
          name="period_end"
          class="form-control"
          :placeholder="$t('ph_period_end')"
          v-model="query.end"
        />
      </div>
  </LDBsTable>
</div>

</template>

<script>
import LoaderButton from '@/components/button/LoaderButton'
import { request } from '@/lib/http'
import { mapState } from 'vuex'
import LDBsTable from '@/components/shared/LDBsTable'
import Combobox from '@/components/shared/ComboBox'
import moment from 'moment'
import { baseUrlReports } from '@/lib/config'
import axios from 'axios'

export default {
  name: 'ReportDriveBehavior',

  components: {
    LDBsTable,
    LoaderButton,
    Combobox
  },

  data () {
    return {
      columns: [
        {
          title: this.$t('datetime'),
          field: 'data_hora_comportamento_motorista',
          formatter: value => moment(value).format('DD/MM/YYYY HH:mm:ss')
        },
        {
          title: this.$t('vehicle'),
          field: 'id_veiculo',
          formatter: (value, row, index) => this.mountText(row, 'vehicle', value)
        },
        {
          title: this.$t('drive'),
          field: 'id_motorista',
          formatter: (value, row, index) => this.mountText(row, 'drive', value)
        },
        {
          title: this.$t('lat/lon'),
          field: 'coordinates'
        },
        {
          title: this.$t('speed'),
          field: 'velocidade_comportamento_motorista',
        },
        {
          title: this.$t('ignition'),
          field: 'ignicao_comportamento_motorista',
          formatter: value => value ? 'SIM' : 'NÃO'
        },
        {
          title: 'GPS',
          field: 'gps_comportamento_motorista',
          formatter: value => value ? 'SIM' : 'NÃO'
        },
        {
          title: 'GPRS',
          field: 'gprs_comportamento_motorista',
          formatter: value => value ? 'SIM' : 'NÃO'
        },
        {
          title: this.$t('reason'),
          field: 'motivo_comportamento_motorista',
          formatter: (value, row) => `${value} - ${row.reason}`
        },
      ],
      query: {
        vehicle: undefined,
        drive: undefined,
        reason: undefined,
        client: undefined,
        start: '',
        end: ''
      },
      queryToUse: {},
      options: {
        exportOptions: { fileName: 'drivebehaviors' }
      },
      loading: false,
      reasons: [
        { id: 253, label: 'Curva Acentuada' },
        { id: 254, label: 'Frenagem Brusca' },
        { id: 255, label: 'Aceleração Brusca' },
      ],
      drives: [],
      vehicles: [],
      clients: []
    }
  },

  computed: {
    ...mapState({
      lastquery: state => state.filtershistory.query
    })
  },

  methods: {
    clear() {
      this.query.vehicle = undefined
      this.query.drive = undefined
      this.query.reason = undefined
      this.query.client = undefined
      this.query.start = ''
      this.query.end = ''

      this.$store.dispatch('filtershistory/setQuery', { key: 'drivebehavior', query: this.query })
    },

    mountText(item, property, defaultValue) {
      if (item[property]) {
        const values = []

        for (const [, value] of Object.entries(item[property])) {
          value && values.push(value)
        }

        return values.join(' - ')
      }

      return defaultValue
    },

    async filtersDriveBehavior() {
      try {
        const { vehicles, drives, clients } = await request({
          method: 'get',
          url: `drive-behavior/filters`
        })

        this.vehicles = vehicles
        this.drives = drives
        this.clients = clients
      } catch (error) {
        console.log('[FILTERS-DRIVE-BEHAVIOR] => ', error)
      }
    },

    async generatePDF() {
      try {
        const data = await request({
          method: 'get',
          url: `drive-behavior/pdf`,
          params: this.queryToUse
        })

        axios({
          url: baseUrlReports(),
          method: 'post',
          data: data,
          responseType: 'blob'
        })
          .then(response => {
            const file = new Blob(
              [response.data],
              { type: 'application/pdf' }
            )
            const fileURL = URL.createObjectURL(file)
            window.open(fileURL, "_blank")
          })
            .catch(error => console.log('[ERROR-PRINT-PDF] => ', error))
      } catch (error) {
        console.log('[ERROR-GENERATE-PDF] => ', error)
      } finally {
        setTimeout(() => $('#modalLoading').modal('hide'), 1000);
      }
    }
  },

  beforeMount() {
    this.queryToUse = this.lastquery['drivebehavior'] ? this.lastquery['drivebehavior'] : this.query
  },

  async mounted () {
    if (this.lastquery['drivebehavior']) {
      for (const [key, value] of Object.entries(this.lastquery['drivebehavior'])) {
        this.query[key] = value
      }
    }

    this.queryToUse = this.query

    await this.filtersDriveBehavior()

    const global = this

    $('#btn_print_drive_behavior').on('click', function() {
      const hasFilter = Object.values(global.query).some(Boolean)

      if (!hasFilter) {
        return global.$store.dispatch('notify/error', { message: 'É necessário inserir pelo menos 1 (um) filtro!' })
      }

      $('#modalLoading').modal('show')
    })

    $('#modalLoading').on('show.bs.modal', function (event) {
      global.generatePDF()
    })
  },

  destroyed () {
    this.$store.dispatch('filtershistory/setQuery', { key: 'drivebehavior', query: this.query })
  },
}
</script>
